<template>
    <v-container>

        <loading-overlay :active="pageLoading" :is-full-page="true" :lock-scroll="true" loader="dots" color="#0168b7"
                background-color="#ffffff" opacity="1" />

        <v-window :touch="{left: null, right: null}" v-model="toggle_tab" class="mb-12">

            <v-window-item
                value="newsList"
            >

                <h2>最新のお知らせ</h2>

                <div class="news-list">
                    <div v-for="(news, $index) in newsList" :key="$index" class="news-list--item">
                        <article-tile
                            :content-title="news.article_title"
                            :content-lead="news.article_txt"
                            :content-author="news.fund_name"
                            :content-uri="`/api/fund/news/${news.fund_id}/${news.article_id}`"
                            :thumbnail-uri="`/data/fund/${news.fund_id}/top.jpg`"
                            :timestamp="dateFormat(news.posting_datetime)"
                            :show-sns-share="true"
                        />
                    </div>
                    <InfiniteLoading @infinite="infiniteNewsListHandler">
                        <template #complete>
                            <span> </span>
                        </template>
                    </InfiniteLoading>
                </div>
                <div v-if="isNewsListEmpty" class="text-center">
                    お知らせはありません
                </div>
            </v-window-item>

            <v-window-item
                value="watchList"
            >


                <TabWatchList :key="refleshKey" />


            </v-window-item>

        </v-window>

        <div class="text-center" style="position: fixed; left: 0; bottom: 100px; width: 100%;">
            <v-btn-toggle
                v-model="toggle_tab"
                background-color="white"
                color="primary"
                rounded="xl"
                elevation="4"
                size="x-small"
                density="compact"
                variant="flat"
            >
                <v-btn
                    value="newsList"
                    min-width="120"
                    size="small"
                    density="compact"
                >
                    最新のお知らせ
                </v-btn>
                <v-btn
                    value="watchList"
                    min-width="120"
                    size="small"
                    density="compact"
                >
                    アイテム管理
                </v-btn>
            </v-btn-toggle>
        </div>
        
    </v-container>
    
</template>

<style scoped>
.v-window-item{
    min-height: 80vh;
}
.news-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 800px;
}

.news-list--item{
    width: 100%;
}
</style>

<script>
import axios from "axios"
import InfiniteLoading from "v3-infinite-loading"
import "v3-infinite-loading/lib/style.css"
import LoadingOverlay from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import ArticleTile from "../components/ArticleTile"
import TabWatchList from "../views/TabWatchList"
import helper from '../assets/js/helper'

const newsListApi = '/api/watch/news'

export default {
    name: 'WatchList',
    components: {
        InfiniteLoading,
        LoadingOverlay,
        TabWatchList,
        ArticleTile
    },
    data: () => ({
        pageLoading: true,
        newsListPage: 0,
        newsList: [],
        tab_id: 'newsList',
        isNewsListEmpty: false,
        isWatchListEmpty: false,
        refleshKey: 0
    }),
    computed: {
        toggle_tab: {
            get(){
                return this.tab_id
            },
            set(newVal){
                if( newVal == null ){
                    return
                }
                this.tab_id = newVal
            }
        }
    },
    mounted() {},
    created: async function() {
            const accessParams = new URLSearchParams();
            accessParams.append('page_type', 'watchlist');
            await axios.post('/api/spa/page/access', accessParams).catch(() => {
                return;
            });
    },
    watch: {
        '$route': 'refreshComponent'
    },
    methods: {
        async refreshComponent() {
            this.refleshKey = this.refleshKey + 1
        },
        dateFormat: (date) => {
            return helper.formatDate(date)
        },
        async infiniteNewsListHandler($state) {

            const res = await axios.get(newsListApi, {
                params: {
                    limit: 10,
                    pg: this.newsListPage
                }                
            }).catch((error) => {
                console.log(error)
                return;
            });

            console.log(res)

            if (res.data.length > 0) {
                this.newsListPage++;
                this.newsList.push(...res.data);
                $state.loaded();
            } else {
                $state.complete();
                this.isNewsListEmpty = this.newsList.length == 0
            }

            this.$nextTick(() => {
                this.pageLoading = false
            })

        }
    }
}
</script>